import { subscriptionCardBigIF } from '../components/SubscriptionCard/subscriptionCardBigIF'

export const individualAccountHowItWorks: Array<{
  title: string
  content: string
}> = [
  {
    title: `Choose your plan`,
    content: `The subscription-based plans provide predictable monthly fees, while the commission-based plan is ideal for those who prefer a flexible cost model.`,
  },
  {
    title: `Set up your profile`,
    content: `Create your professional profile. Include the information  that clients need to understand your expertise and see your availability.`,
  },
  {
    title: `Engage with clients`,
    content: `With tools for scheduling and calendar management, clients can book appointments directly through your profile. You’ll receive real-time notifications and can manage your calendar easily from the portal.`,
  },
  {
    title: `Track performance and grow`,
    content: `Use the booking analytics dashboard to monitor your profile’s performance and understand your client base better. You may wish to upgrade or customise your profile to enhance engagement.`,
  },
]

export const individualAccountSubscriptionCards: Array<subscriptionCardBigIF> =
  [
    {
      tabColor: 'bg-[#58C1B3]',
      title: 'Standard subscription',
      subTitle: 'Tier: Single profile',
      amount: '£449',
      vatAddition: true,
      recurrence: 'per month',
      dueOnReceiptOfClientPayment: false,
      featureList: {
        title: '',
        features: [
          {
            text: 'Standard professional profile: Create a comprehensive profile that highlights your expertise and attracts clients.',
            additionalInfo:
              'A standard professional profile is custom to an individual, provides additional information to users, ranks higher in search results and enables appointment booking.',
          },
          {
            text: 'Standard firm profile: Build a profile that represents your firm or practice.',
            additionalInfo:
              'A standard firm profile is custom to an individual entity, provides additional information to users, ranks higher in search results and promotes associated individual profiles.',
          },
          {
            text: 'Live booking analytics dashboard: Access real-time data on your bookings to monitor engagement and identify trends.',
            additionalInfo: '',
          },
          {
            text: "Profile listing on Find a Lawyer: Increase your visibility with a listing on Legal Utopia's Find a Lawyer feature.",
            additionalInfo: '',
          },
          {
            text: 'Integration with Book a Lawyer: Allow clients to schedule appointments on your profile page.',
            additionalInfo: '',
          },
          {
            text: 'Booking, Scheduling, and Calendar Management: Streamline client interactions with integrated scheduling tools.',
            additionalInfo: '',
          },
          {
            text: 'Availability Customisation: Manage your availability and schedule.',
            additionalInfo: '',
          },
          {
            text: 'Profile Management Access: Update your profile information easily from the portal.',
            additionalInfo: '',
          },
          {
            text: 'Account Support: Access live support Monday to Friday, 9am-5pm (GMT/BST).*',
            additionalInfo: '',
          },
        ],
      },
      buttonLabel: 'Subscribe',
      buttonLink: '/',
    },
    {
      tabColor: 'bg-[#8484F6]',
      title: 'Premium subscription',
      subTitle: 'Tier: Single profile',
      amount: '£569',
      vatAddition: true,
      recurrence: 'per month',
      dueOnReceiptOfClientPayment: false,
      featureList: {
        title: 'Includes all Standard Subscription features, plus:',
        features: [
          {
            text: 'Premium Professional Profile: Create a more detailed profile with additional',
            additionalInfo:
              'A premium professional profile is custom to an individual, provides enhanced information to users, ranks highest in search results and enables appointment booking.',
          },
          {
            text: 'Premium Firm Profile: Enhance your profile  to boost brand recognition and client engagement.',
            additionalInfo:
              'A premium firm profile is custom to an individual entity, provides enhanced information to users, ranks highest in search results and promotes associated individual profiles.',
          },
          {
            text: "Priority Profile Ranking: Optimise  your profile's search ranking for higher visibility.",
            additionalInfo: '',
          },
          {
            text: 'Enhanced Profile Information: Add more details to your profile to showcase your experience and specialisations.',
            additionalInfo: '',
          },
        ],
      },
      buttonLabel: 'Subscribe',
      buttonLink: '',
    },
    {
      tabColor: 'bg-[#122D5C]',
      title: 'Standard commision plan',
      subTitle: 'Tier: Single profile',
      amount: '15% commission',
      vatAddition: true,
      recurrence: '',
      dueOnReceiptOfClientPayment: true,
      featureList: {
        title: '',
        features: [
          {
            text: 'Flexible Payment Model: Pay a 15% commission on client payments instead of a fixed monthly fee.',
            additionalInfo: '',
          },
          {
            text: 'All Standard Subscription Features: This includes all the features of the Standard Subscription plan, with no fixed monthly cost.',
            additionalInfo: '',
          },
        ],
      },
      buttonLabel: 'Join',
      buttonLink: '',
    },
  ]
